var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page_section_inner"
  }, [_vm._m(0), _c('div', {
    staticClass: "episode_list_wrap"
  }, [_c('EpisodeList', {
    attrs: {
      "episode-list": _vm.episodeList
    },
    on: {
      "itemClick": _vm.itemClickHandler
    }
  })], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page_title_wrap type2"
  }, [_c('h3', {
    staticClass: "page_title_text"
  }, [_vm._v("연재 목록")])]);
}]

export { render, staticRenderFns }